import "../styles/App.scss";
import { Col, Row, Container, Button } from "react-bootstrap";

function StartPage(props) {
    const handleStart = () => {
        props.setCurrentPage(() => props.currentPage + 1);
    };

    return (

            <div className="background-image" style={{ backgroundImage: `url(/images/background-1.png)` }}>
                <Container>
                    <Row className="justify-content-md-center title-row">
                        <Col>
                            <h1 className="title">
                                你是哪種
                                <br />
                                夢想探險家？
                            </h1>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col>
                            <h2 className="title">
                                用MBTI 發現你的個性
                                <br />
                                找到屬於你的安心選擇
                            </h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <img
                                src="/images/explorer.png"
                                className="explorer"
                                alt="explorer"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className="start-button"
                                variant="primary"
                                size="lg"
                                onClick={handleStart}
                            >
                                開始探索
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>

    );
}

export default StartPage;
